const ATTRIBUTES: any = {
  class: 'className',
  for: 'htmlFor',
  maxlength: 'maxLength',

  colspan: 'colSpan',
  rowspan: 'rowSpan'
};

export default ATTRIBUTES;
